/**
 * Mock employees to display the full capabilities of the Table component.
*/
export const mockEmployees = [
    {
        "firstName": "Tony",
        "lastName": "Stark",
        "birthday": "1970-05-29T12:00:58.971Z",
        "street": "3000 Potts Avenue",
        "city": "Huntsville",
        "state": {
            "abbreviation": "AL",
            "name": "Alabama"
        },
        "zipCode": "35801",
        "startDate": "2023-04-12T12:00:58.971Z",
        "department": "Engineering"
    },
    {
        "firstName": "James",
        "lastName": "Rhodes",
        "birthday": "1968-10-06T12:00:58.971Z",
        "street": "257 Machine Lane",
        "city": "Ketchikan",
        "state": {
            "abbreviation": "AK",
            "name": "Alaska"
        },
        "zipCode": "99901",
        "startDate": "2022-04-18T12:00:58.971Z",
        "department": "Sales"
    },
    {
        "firstName": "Thor",
        "lastName": "Odinson",
        "birthday": "1975-03-03T12:00:58.971Z",
        "street": "3 Mjölnir Boulevard",
        "city": "Phoenix",
        "state": {
            "abbreviation": "AZ",
            "name": "Arizona"
        },
        "zipCode": "85004",
        "startDate": "2021-06-30T12:00:58.971Z",
        "department": "Sales"
    },
    {
        "firstName": "Loki",
        "lastName": "Laufeyson",
        "birthday": "1983-07-21T12:00:58.971Z",
        "street": "355 Mischief Street",
        "city": "Little Rock",
        "state": {
            "abbreviation": "AR",
            "name": "Arkansas"
        },
        "zipCode": "72219",
        "startDate": "2021-01-01T12:00:58.971Z",
        "department": "Marketing"
    },
    {
        "firstName": "Jane",
        "lastName": "Foster",
        "birthday": "1980-06-12T12:00:58.971Z",
        "street": "431 Mighty Avenue",
        "city": "San Francisco",
        "state": {
            "abbreviation": "CA",
            "name": "California"
        },
        "zipCode": "94107",
        "startDate": "2020-11-06T12:00:58.971Z",
        "department": "Engineering"
    },
    {
        "firstName": "Steve",
        "lastName": "Rogers",
        "birthday": "1918-07-04T12:00:58.971Z",
        "street": "981 Resiliency Boulevard",
        "city": "Denver",
        "state": {
            "abbreviation": "CO",
            "name": "Colorado"
        },
        "zipCode": "80201",
        "startDate": "2020-10-23T12:00:58.971Z",
        "department": "Human Resources"
    },
    {
        "firstName": "Peggy",
        "lastName": "Carter",
        "birthday": "1921-04-09T12:00:58.971Z",
        "street": "13 Captain Street",
        "city": "Columbia",
        "state": {
            "abbreviation": "CT",
            "name": "Connecticut"
        },
        "zipCode": "06237",
        "startDate": "2020-09-23T12:00:58.971Z",
        "department": "Sales"
    },
    {
        "firstName": "Bucky",
        "lastName": "Barnes",
        "birthday": "1917-10-03T12:00:58.971Z",
        "street": "71 White Wolf Avenue",
        "city": "Wilmington",
        "state": {
            "abbreviation": "DE",
            "name": "Delaware"
        },
        "zipCode": "19804",
        "startDate": "2020-09-16T12:00:58.971Z",
        "department": "Marketing"
    },
    {
        "firstName": "Bruce",
        "lastName": "Banner",
        "birthday": "1969-12-18T12:00:58.971Z",
        "street": "809 Skaar Street",
        "city": "Orlando",
        "state": {
            "abbreviation": "FL",
            "name": "Florida"
        },
        "zipCode": "32804",
        "startDate": "2020-06-17T12:00:58.971Z",
        "department": "Engineering"
    },
    {
        "firstName": "Natasha",
        "lastName": "Romanoff",
        "birthday": "1984-12-03T12:00:58.971Z",
        "street": "85 Yelena Boulevard",
        "city": "Atlanta",
        "state": {
            "abbreviation": "GE",
            "name": "Georgia"
        },
        "zipCode": "30322",
        "startDate": "2020-03-11T12:00:58.971Z",
        "department": "Human Resources"
    },
    {
        "firstName": "Clint",
        "lastName": "Barton",
        "birthday": "1972-03-22T12:00:58.971Z",
        "street": "129 Ronin Street",
        "city": "Honolulu",
        "state": {
            "abbreviation": "HI",
            "name": "Hawaii"
        },
        "zipCode": "96801",
        "startDate": "2020-01-10T12:00:58.971Z",
        "department": "Legal"
    },
    {
        "firstName": "Phil",
        "lastName": "Coulson",
        "birthday": "1964-07-08T12:00:58.971Z",
        "street": "456 Shield Avenue",
        "city": "Boise",
        "state": {
            "abbreviation": "ID",
            "name": "Idaho"
        },
        "zipCode": "83703",
        "startDate": "2019-12-19T12:00:58.971Z",
        "department": "Human Resources"
    },
    {
        "firstName": "Peter",
        "lastName": "Quill",
        "birthday": "1980-12-22T12:00:58.971Z",
        "street": "922 Footlose Street",
        "city": "Chicago",
        "state": {
            "abbreviation": "IL",
            "name": "Illinois"
        },
        "zipCode": "60605",
        "startDate": "2019-07-12T12:00:58.971Z",
        "department": "Sales"
    },
    {
        "firstName": "Gamora",
        "lastName": "Titan",
        "birthday": "1984-06-04T12:00:58.971Z",
        "street": "193 Moonage Avenue",
        "city": "Indianapolis",
        "state": {
            "abbreviation": "IN",
            "name": "Indiana"
        },
        "zipCode": "46204",
        "startDate": "2018-10-03T12:00:58.971Z",
        "department": "Legal"
    },
    {
        "firstName": "Scott",
        "lastName": "Lang",
        "birthday": "1969-04-06T12:00:58.971Z",
        "street": "473 Ant Boulevard",
        "city": "Orange City",
        "state": {
            "abbreviation": "IA",
            "name": "Iowa"
        },
        "zipCode": "51041",
        "startDate": "2017-09-27T12:00:58.971Z",
        "department": "Human Resources"
    },
    {
        "firstName": "Hank",
        "lastName": "Pym",
        "birthday": "1944-09-25T12:00:58.971Z",
        "street": "2678 Quantum Street",
        "city": "Kansas City",
        "state": {
            "abbreviation": "KS",
            "name": "Kansas"
        },
        "zipCode": "66103",
        "startDate": "2017-06-14T12:00:58.971Z",
        "department": "Engineering"
    },
    {
        "firstName": "Hope",
        "lastName": "Van Dyne",
        "birthday": "1979-08-03T12:00:58.971Z",
        "street": "364 Wasp Avenue",
        "city": "Louisville",
        "state": {
            "abbreviation": "KY",
            "name": "Kentucky"
        },
        "zipCode": "40235",
        "startDate": "2016-12-02T12:00:58.971Z",
        "department": "Legal"
    },
    {
        "firstName": "Wanda",
        "lastName": "Maximoff",
        "birthday": "1989-01-16T12:00:58.971Z",
        "street": "123 Scarlet Boulevard",
        "city": "Lewiston",
        "state": {
            "abbreviation": "ME",
            "name": "Maine"
        },
        "zipCode": "04240",
        "startDate": "2016-08-16T12:00:58.971Z",
        "department": "Marketing"
    },
    {
        "firstName": "Sam",
        "lastName": "Wilson",
        "birthday": "1978-09-23T12:00:58.971Z",
        "street": "357 Falcon Street",
        "city": "New Orleans",
        "state": {
            "abbreviation": "LA",
            "name": "Louisiana"
        },
        "zipCode": "70116",
        "startDate": "2016-03-17T12:00:58.971Z",
        "department": "Marketing"
    },
    {
        "firstName": "Peter",
        "lastName": "Parker",
        "birthday": "2001-10-08T12:00:58.971Z",
        "street": "478 Spider Boulevard",
        "city": "Baltimore",
        "state": {
            "abbreviation": "MD",
            "name": "Maryland"
        },
        "zipCode": "21201",
        "startDate": "2020-02-08T12:00:58.971Z",
        "department": "Engineering"
    },
    {
        "firstName": "Stephen",
        "lastName": "Strange",
        "birthday": "1976-07-19T12:00:58.971Z",
        "street": "736 Mystic Arts Avenue",
        "city": "Boston",
        "state": {
            "abbreviation": "MA",
            "name": "Massachusetts"
        },
        "zipCode": "02108",
        "startDate": "2015-05-12T12:00:58.971Z",
        "department": "Legal"
    },
    {
        "firstName": "May",
        "lastName": "Parker",
        "birthday": "1964-07-05T12:00:58.971Z",
        "street": "854 Feast Street",
        "city": "Ann Arbor",
        "state": {
            "abbreviation": "MI",
            "name": "Michigan"
        },
        "zipCode": "48103",
        "startDate": "2015-04-27T12:00:58.971Z",
        "department": "Human Resources"
    },
    {
        "firstName": "Happy",
        "lastName": "Hogan",
        "birthday": "1966-10-19T12:00:58.971Z",
        "street": "64 Security Boulevard",
        "city": "Minneapolis",
        "state": {
            "abbreviation": "MN",
            "name": "Minnesota"
        },
        "zipCode": "55403",
        "startDate": "2015-01-21T12:00:58.971Z",
        "department": "Legal"
    },
    {
        "firstName": "MJ",
        "lastName": "Watson",
        "birthday": "2001-06-10T12:00:58.971Z",
        "street": "401 Sarcasm Avenue",
        "city": "Jackson",
        "state": {
            "abbreviation": "MS",
            "name": "Mississippi"
        },
        "zipCode": "39204",
        "startDate": "2023-04-04T12:00:58.971Z",
        "department": "Engineering"
    },
    {
        "firstName": "Ned",
        "lastName": "Leeds",
        "birthday": "2001-11-10T12:00:58.971Z",
        "street": "384 Chair Guy Street",
        "city": "St. Louis",
        "state": {
            "abbreviation": "MO",
            "name": "Missouri"
        },
        "zipCode": "63105",
        "startDate": "2022-08-30T12:00:58.971Z",
        "department": "Engineering"
    },
    {
        "firstName": "Brunnhilde",
        "lastName": "Valkyrie",
        "birthday": "1983-10-03T12:00:58.971Z",
        "street": "93 New Asgard Boulevard",
        "city": "Omaha",
        "state": {
            "abbreviation": "NE",
            "name": "Nebraska"
        },
        "zipCode": "68101",
        "startDate": "2022-08-24T12:00:58.971Z",
        "department": "Marketing"
    },
    {
        "firstName": "Carol",
        "lastName": "Danvers",
        "birthday": "1964-09-03T12:00:58.971Z",
        "street": "129 Marvel Avenue",
        "city": "Las Vegas",
        "state": {
            "abbreviation": "NV",
            "name": "Nevada"
        },
        "zipCode": "89054",
        "startDate": "2022-06-29T12:00:58.971Z",
        "department": "Sales"
    },
    {
        "firstName": "Nick",
        "lastName": "Fury",
        "birthday": "1950-07-04T12:00:58.971Z",
        "street": "753 Foxtrot Street",
        "city": "Newark",
        "state": {
            "abbreviation": "NJ",
            "name": "New Jersey"
        },
        "zipCode": "07102",
        "startDate": "2021-02-17T12:00:58.971Z",
        "department": "Sales"
    },
    {
        "firstName": "Monica",
        "lastName": "Rambeau",
        "birthday": "1983-06-07T12:00:58.971Z",
        "street": "820 Photon Boulevard",
        "city": "Albuquerque",
        "state": {
            "abbreviation": "NM",
            "name": "New Mexico"
        },
        "zipCode": "87106",
        "startDate": "2015-11-06T12:00:58.971Z",
        "department": "Engineering"
    },
    {
        "firstName": "Kate",
        "lastName": "Bishop",
        "birthday": "2002-01-27T12:00:58.971Z",
        "street": "492 Hawkeye Avenue",
        "city": "New York",
        "state": {
            "abbreviation": "NY",
            "name": "New York"
        },
        "zipCode": "10001",
        "startDate": "2021-12-30T12:00:58.971Z",
        "department": "Sales"
    },
    {
        "firstName": "Marc",
        "lastName": "Spector",
        "birthday": "1987-09-03T12:00:58.971Z",
        "street": "478 Khonshu Street",
        "city": "Charlotte",
        "state": {
            "abbreviation": "NC",
            "name": "North Carolina"
        },
        "zipCode": "28207",
        "startDate": "2020-11-09T12:00:58.971Z",
        "department": "Marketing"
    },
    {
        "firstName": "Jimmy",
        "lastName": "Woo",
        "birthday": "1976-04-12T12:00:58.971Z",
        "street": "7248 Magic Trick Boulevard",
        "city": "Fargo",
        "state": {
            "abbreviation": "ND",
            "name": "North Dakota"
        },
        "zipCode": "58103",
        "startDate": "2017-11-01T12:00:58.971Z",
        "department": "Human Resources"
    },
    {
        "firstName": "Kamala",
        "lastName": "Khan",
        "birthday": "2007-03-17T12:00:58.971Z",
        "street": "280 Cosmic Avenue",
        "city": "Lima",
        "state": {
            "abbreviation": "OH",
            "name": "Ohio"
        },
        "zipCode": "45801",
        "startDate": "2023-09-01T12:00:58.971Z",
        "department": "Human Resources"
    },
    {
        "firstName": "Bruno",
        "lastName": "Carrelli",
        "birthday": "2006-09-23T12:00:58.971Z",
        "street": "273 Caltech Boulevard",
        "city": "Oklahoma City",
        "state": {
            "abbreviation": "OK",
            "name": "Oklahoma"
        },
        "zipCode": "73102",
        "startDate": "2023-03-03T12:00:58.971Z",
        "department": "Engineering"
    },
    {
        "firstName": "Jennifer",
        "lastName": "Walters",
        "birthday": "1993-08-10T12:00:58.971Z",
        "street": "273 Fuzzball Street",
        "city": "Portland",
        "state": {
            "abbreviation": "OR",
            "name": "Oregon"
        },
        "zipCode": "97086",
        "startDate": "2017-11-01T12:00:58.971Z",
        "department": "Legal"
    },
    {
        "firstName": "Matt",
        "lastName": "Murdock",
        "birthday": "1982-12-15T12:00:58.971Z",
        "street": "823 Daredevil Avenue",
        "city": "San Juan",
        "state": {
            "abbreviation": "PR",
            "name": "Puerto Rico"
        },
        "zipCode": "00901",
        "startDate": "2015-11-30T12:00:58.971Z",
        "department": "Legal"
    }
];